module.exports = __webpack_public_path__ + "static/media/heros_en.f5cd8a77.png";